<header class="app-shell" [class.app-shell--guest]="!isAuthenticated">
  <h1 class="app-shell__title">AACR Management</h1>

  <ng-container *ngIf="isAuthenticated">
    <nav class="tabs app-shell__tabs" aria-label="Main navigation">
      <ul>
        <li routerLinkActive="is-active">
          <a routerLink="/home">Home</a>
        </li>
        <li *ngIf="canAccessApplications" routerLinkActive="is-active">
          <a routerLink="/applications">Applications</a>
        </li>
      </ul>
    </nav>

    <div class="app-shell__spacer" aria-hidden="true"></div>

    <app-role-pills class="app-shell__roles"></app-role-pills>

    <button type="button" class="button is-light is-small app-shell__logout" (click)="logout()">
      Logout
    </button>
  </ng-container>
</header>

<router-outlet></router-outlet>